export const meta: BlockMeta = {
  title: "Columns",
  description: "Break content up into columns",
  keywords: ["columns"],
  tags: ["root"],
  icon: "format-aside",
  category: "layouts",
  conditions: {
    postTypes: ["page", "article", "resource"],
  },
}

import { PanelBody, RadioControl } from "@wordpress/components"
import clsx from "clsx"
import { defineBlock, InnerBlocks, InspectorControls, useInlineEditableValue } from "eddev/blocks"

export default defineBlock("layout/columns", (props) => {
  const [layout, setLayout] = useInlineEditableValue("layout", "two")
  return (
    <div className={clsx("grid-auto mx-0 block-columns", layout === "two" ? "md:auto-cols-6" : "md:auto-cols-9")}>
      <InspectorControls>
        <PanelBody title="Layout">
          <RadioControl
            label="Columns"
            selected={layout}
            options={[
              { label: "Three Columns", value: "three" },
              { label: "Two Columns", value: "two" },
            ]}
            onChange={setLayout}
          />
        </PanelBody>
      </InspectorControls>
      <InnerBlocks allowedBlocks={["layout/column"]} adminClassName="col-span-max grid-auto" appender={{ type: "button" }} />
    </div>
  )
})
